<form name="requestInfoForm" [formGroup]="requestInfoForm" (ngSubmit)="checkPermission()" novalidate>

  @if (mode === 'stand') {
    <section class="my-6 md:my-0">
      <label i18n>Type of request:</label>
      @if (mode === 'stand') {
        <mat-radio-group class="flex flex-wrap md:flex-nowrap" formControlName="reqType" [value]="requestType">
          <mat-radio-button value="videocall" i18n>Videocall</mat-radio-button>
          <mat-radio-button value="message" i18n>Message</mat-radio-button>
          <mat-radio-button value="catalog" i18n>Catalog</mat-radio-button>
        </mat-radio-group>
      } @else {
        <input type="hidden" value="portal-request" formControlName="reqType"/>
      }
    </section>
  }

  <div class="flex flex-col-reverse md:flex-row w-full min-h-[200px] mb-5">
    <mat-form-field class="text-area flex-grow !w-full md:w-3/4 h-full" appearance="outline">
      <mat-label i18n>Request information</mat-label>
      <textarea matInput
        formControlName="text"
        cdkTextareaAutosize
        #autosize="cdkTextareaAutosize"
        cdkAutosizeMinRows="8"
      cdkAutosizeMaxRows="15"></textarea>
    </mat-form-field>
    <ng-content> </ng-content>
  </div>


  <mat-form-field appearance="outline">
    <mat-label i18n>Company name</mat-label>
    <input matInput formControlName="company" name="company">
  </mat-form-field>

  @if (mode === 'contacts') {
    <mat-form-field appearance="outline">
      <mat-label i18n>Email</mat-label>
      <input matInput required formControlName="mail" name="mail">
      @if (requestInfoForm.get('mail').hasError('required')) {
        <mat-error i18n>
            Email is required
        </mat-error>
      }
      @if (requestInfoForm.get('mail').hasError('mail')) {
        <mat-error i18n>
            Please enter a valid email address
        </mat-error>
      }
    </mat-form-field>
  }

  <mat-form-field appearance="outline">
    <mat-label i18n>Telephone</mat-label>
    <ngx-mat-intl-tel-input [inputPlaceholder]="placeholder"
      [preferredCountries]="['us', 'gb', 'it', 'de', 'fr', 'es']" formControlName="phone"
      [enablePlaceholder]="true" [enableSearch]="true" name="phone" #phone>
    </ngx-mat-intl-tel-input>
  </mat-form-field>
  <div class="flex flex-row space-x-4">
    <button class="submit-button uppercase w-full md:w-auto" mat-raised-button color="accent" aria-label="SEND"
      [disabled]="requestInfoForm.invalid || requestSent" i18n>
            send request
        </button>
    @if (requestSent) {
      <div class="text-green-500 text-xl justify-center flex items-center" i18n>Request sent successfully.</div>
    }
  </div>
</form>
